module.exports = __webpack_public_path__ + "img/tp6.027ed7e8.png";